export default {"src":"/_next/static/media/Pause.8b4f81b6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};